import React, { useRef } from 'react';
import dayjs from 'dayjs';
import useForm from 'components/use-form';
import AgencyInfoEdit from 'pages/regist/formComponent/CompanyInfo';
import { AgencyDetailProps } from '../../use-agency-detail';
import { AgencyInfo } from 'model/agency';
import { agencyInfoFormConfig } from '../config';

const AgencyInfo: React.FC<AgencyDetailProps> = (props) => {
  const formRef = useRef<any>();
  const data = props.data?.agency_info || {};

  const { Form } = useForm({
    data,
    mode: 'text',
    title: '服务商信息',
    config: agencyInfoFormConfig,
    EditComponent: AgencyInfoEdit,
    editProps: {
      initData: data,
      ref: formRef,
    },
    onSubmit: async (editClose) => {
      const formData = formRef?.current?.submit?.() as AgencyInfo;
      if (!formData) return;
      const data = {
        ...formData,
        company_created_time: dayjs(formData.company_created_time).format('YYYY-MM-DD 00:00:00'),
      };
      const isSuccess = await props.onUpdate({ agency_info: data });
      if (isSuccess) {
        editClose();
      }
    },
  });

  return Form;
};

export default AgencyInfo;
